import React from 'react';
import ReactDOM from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { AuthProvider } from './AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { ToastProvider } from './contexts/ToastContext';
import { ToastContainer, ConfirmDialog } from './components/Toast';
import { PrivateRoute, CustomerRedirect, LoginRoute } from './App';
import Login from './pages/Login';
import ChatbotList from './pages/ChatbotList';
import ChatbotDetail from './pages/ChatbotDetail';
import ChatbotPreview from './pages/ChatbotPreview';
import Settings from './pages/Settings';
import InternalSalesReference from './pages/InternalSalesReference';
import SetPassword from './pages/SetPassword';
import './index.css';

const router = createBrowserRouter([
  {
    path: '/set-password/:token',
    element: <SetPassword />,
  },
  {
    path: '/login',
    element: (
      <LoginRoute>
        <Login />
      </LoginRoute>
    ),
  },
  {
    path: '/',
    element: (
      <PrivateRoute>
        <CustomerRedirect>
          <ChatbotList />
        </CustomerRedirect>
      </PrivateRoute>
    ),
  },
  {
    path: '/chatbots/:id',
    element: (
      <PrivateRoute>
        <ChatbotDetail />
      </PrivateRoute>
    ),
  },
  {
    path: '/chatbots/:id/preview',
    element: (
      <PrivateRoute>
        <ChatbotPreview />
      </PrivateRoute>
    ),
  },
  {
    path: '/settings',
    element: (
      <PrivateRoute>
        <Settings />
      </PrivateRoute>
    ),
  },
  {
    path: '/sales-reference',
    element: (
      <PrivateRoute>
        <CustomerRedirect>
          <InternalSalesReference />
        </CustomerRedirect>
      </PrivateRoute>
    ),
  },
]);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <ToastProvider>
          <RouterProvider router={router} />
          <ToastContainer />
          <ConfirmDialog />
        </ToastProvider>
      </AuthProvider>
    </ThemeProvider>
  </React.StrictMode>
);
